<template>
  <div class="welcome-card">
    <div class="main-head">Welcome to Eco-Niwas Samhita Design Aider</div>
    <div class="subhead">Please select any project to proceed</div>
    <div>
      <v-btn @click="navigateToProject" color="primary">
        Ok
      </v-btn>
      <!-- <i class="light-icon-arrow-back"></i> -->
      <!-- <i class="light-icon-tools"></i> -->
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    activeProject: {
      get: function() {
        return this.$store.state.activeProject;
      },
      set: function(newActive) {
        this.$store.dispatch('setActiveProject', newActive);
      },
    },
    projects: {
      get: function() {
        return this.$store.state.projects;
      },
      set: function(newProjects) {
        this.$store.dispatch('setProjects', newProjects);
      },
    },
  },
  methods: {
    navigateToProject() {
      // if (this.projects) {
      //   this.activeProject = this.activeProject === this.projects[0].projectPath ? '' : this.projects[0].projectPath;
      //   this.$router.push({ name: 'Step1', params: { projectSlug: this.projects[0].projectPath } });
      // }
      this.$router.push('/projects');
    },
  },
};
</script>

<style lang="scss" scoped>
.welcome-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px;
  border-radius: 4px;
  background-color: #5a6978;
  color: #fff;
  max-width: 90%;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 10%);
  transition: all 0.2s ease-in-out;
  background-image: linear-gradient(to right, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.1));
  .main-head {
    font-size: 32px;
    font-weight: 400;
  }
  .subhead {
    font-size: 18px;
    padding: 16px;
  }
  i {
    font-size: 34px;
    font-weight: 400;
  }
}
</style>
